import React, { useContext } from "react";
import { FiCheck } from "react-icons/fi";
import { MdUnfoldMore } from "react-icons/md";
import Select, { components as selectComponents } from "react-select";
import { ThemeContext } from "styled-components";
import { Container, OptionContent } from "./styles";

export const DropdownSelectOrdenation = ({ options, onChange, value }) => {
    const theme = useContext(ThemeContext);

    // Encontra a opção correspondente ao valor atual
    const selectedOption = options.find(opt => opt.value === value) || options[0];

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            padding: '12px 16px',
            fontSize: '14px',
            fontWeight: state.isSelected ? 700 : 500,
            color: state.isSelected ? theme.colors.primary : theme.colors.neutral900,
            backgroundColor: state.isSelected
                ? theme.colors.primary30
                : state.isFocused
                ? theme.colors.neutral50
                : theme.colors.white,
            cursor: 'pointer'
        }),
        control: (provided, state) => ({
            ...provided,
            minHeight: 40,
            borderRadius: 12,
            borderColor: state.isFocused ? theme.colors.primary : theme.colors.neutral200,
            boxShadow: 'none',
            background: theme.colors.white,
            color: theme.colors.neutral900,
            fontSize: '14px',
            fontWeight: '700',
            cursor: 'pointer',
            '&:hover': {
                borderColor: theme.colors.primary
            }
        }),
        singleValue: provided => ({
            ...provided,
            color: theme.colors.neutral900,
            fontWeight: 700
        }),
        menu: provided => ({
            ...provided,
            marginTop: 6,
            borderRadius: 12,
            overflow: 'hidden',
            boxShadow: 'var(--cards)',
            zIndex: 5
        }),
        menuList: provided => ({
            ...provided,
            paddingTop: 0,
            paddingBottom: 0
        }),
    };

    const dropdownIndicator = () => {
        return (
            <MdUnfoldMore size={18} color={theme.colors.primary} />
        );
    }

    const Option = (props) => {
        return (
            <selectComponents.Option {...props}>
                <OptionContent>
                    <span>{props.data.label}</span>
                    {props.isSelected && <FiCheck size={16} color={theme.colors.primary} />}
                </OptionContent>
            </selectComponents.Option>
        );
    }

    const components = {
        Option,
        DropdownIndicator: dropdownIndicator,
        IndicatorSeparator: null,
    }

    return (
        <Container>
            <span className="ordenation-label">Ordenar por:</span>
            <div className="ordenation-select">
                <Select
                    styles={customStyles}
                    isSearchable={false}
                    options={options}
                    components={components}
                    value={selectedOption}
                    onChange={e => {
                        onChange(e.value);
                    }}
                />
            </div>
        </Container>
    );
}
